import { useCallback, useEffect, useMemo, useState } from "react";
import { FirebaseApp } from "@firebase/app";
import { Auth } from "@firebase/auth";
import { logTypeKey } from "./constants/constant";
import { getAnalytics, logEvent } from "firebase/analytics";
import { isEmpty } from "lodash";
import { useQueryParams } from "./components/userContext/queryParamContext";

export let handleGameTracking: (
  trackingName: string,
  type?: string | ""
) => void;

export const useFirebase = () => {
  const [app, setApp] = useState<FirebaseApp>({} as FirebaseApp);
  const [auth, setAuth] = useState<Auth>({} as Auth);
  const [isFirebaseLoading, setIsFirebaseLoading] = useState(true);
  const { queryParams } = useQueryParams();

  const analytics = useMemo(() => {
    if (!isEmpty(app)) {
      const tempAnalytics = getAnalytics(app);
      return tempAnalytics;
    }
  }, [app]);

  const handleTracking = useCallback(
    (trackingName: string, type = "") => {
      if (analytics) {
        const eventKey = `${queryParams && queryParams !== "null" && queryParams !== "undefined" ? queryParams : logTypeKey}${trackingName}${type}`;
        logEvent(analytics, eventKey);
      }
    },
    [analytics, queryParams]
  );

  useEffect(() => {
    handleGameTracking = handleTracking;
  }, [handleTracking]);

  return { app, auth, isFirebaseLoading, handleTracking };
};
